import { render, staticRenderFns } from "./ViewRecipeItem.vue?vue&type=template&id=6f0f2c36&scoped=true&"
import script from "./ViewRecipeItem.vue?vue&type=script&lang=js&"
export * from "./ViewRecipeItem.vue?vue&type=script&lang=js&"
import style0 from "./ViewRecipeItem.vue?vue&type=style&index=0&id=6f0f2c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f2c36",
  null
  
)

export default component.exports